export const black = '#000000'
export const grey = '#808080'
export const white = '#FFFFFF'
export const lightGrey = '#ebecf0'
export const lightBlack = '#172b4d'
